// Transport der Live-Kollaboration: Abo auf den ProjectChannel, periodisches
// `touch` für die Präsenz, sauberes Abmelden beim Verlassen. Das Modul
// entscheidet nichts — es reicht die Nachrichten des Servers weiter
// (Entscheidung in editor/collab.js).

import { createConsumer } from "@rails/actioncable"

// Server-TTL der Präsenz sind 40 s; alle 15 s auffrischen lässt zwei Ausfälle
// hintereinander zu, bevor man aus der Liste fällt.
const TOUCH_MS = 15000

// Ein Consumer pro Seite reicht — er hält genau eine WebSocket-Verbindung,
// über die beliebig viele Abos laufen.
let consumer = null

function sharedConsumer() {
  consumer ||= createConsumer()
  return consumer
}

// Liefert ein Handle mit `touch()` und `dispose()` — oder `null`, wenn gar
// kein Abo zustande kommt.
//
// WICHTIG — alles hier ist additiv: Ohne erreichbaren WebSocket (Cable
// abgeschaltet, Proxy ohne Upgrade, Adapter tot, Verbindung abgelehnt) muss
// der Editor exakt so funktionieren wie ohne dieses Modul. Autosave und
// `lock_version` tragen die Korrektheit allein; der Kanal ist reine Vorwarnung.
// Deshalb ist jeder Zugriff hier in try/catch gehüllt und jeder Fehler wird
// still geschluckt statt gemeldet — ein toter Kanal darf nie eine Fehlermeldung
// über der Konstruktion erzeugen.
export function subscribeToProject({ projectId, onMessage }) {
  try {
    const subscription = sharedConsumer().subscriptions.create(
      { channel: "ProjectChannel", project_id: projectId },
      {
        received(data) {
          try {
            onMessage(data)
          } catch {
            // Eine kaputte Nachricht darf den Kanal nicht mitreißen
          }
        }
      }
    )

    // perform() puffert nicht: Vor dem Verbindungsaufbau und nach einem
    // Abbruch geht der Aufruf ins Leere bzw. wirft. Beides ist in Ordnung,
    // der nächste Takt versucht es erneut.
    const touch = () => {
      try {
        subscription.perform("touch")
      } catch {
        // kein Kanal, keine Präsenz — der Rest des Editors merkt davon nichts
      }
    }

    const timer = setInterval(touch, TOUCH_MS)

    return {
      touch,
      dispose() {
        clearInterval(timer)
        try {
          // Meldet den eigenen Präsenzeintrag ab. Kommt das nicht an (Tab
          // abgestürzt), räumt die TTL auf dem Server nach 40 s auf.
          subscription.unsubscribe()
        } catch {
          // egal — siehe oben
        }
      }
    }
  } catch {
    return null
  }
}
